import {Marked} from 'marked'
import { markedHighlight } from 'marked-highlight'
import hljs from 'highlight.js'
import 'highlight.js/styles/tokyo-night-dark.css'

const marked = new Marked(
    markedHighlight({
        langPrefix: 'hljs language-',
        highlight(code, lang) {
            const language = hljs.getLanguage(lang) ? lang : 'shell'
            let html = hljs.highlight(code, { language }).value
            // 自定义要高亮的linux命令列表
            const cmdList = ['useradd','usermod','passwd','userdel','groupadd','groupmod','chmod','chown','docker','vi','systemctl']
            const reg = new RegExp(`\\b(${cmdList.join('|')})\\b(?![\\w])`,'g')
            html = html.replace(reg, '<span class="hljs-built_in">$1</span>')
            return html
        }
    })
)
export default marked